import React from 'react'

export default ({ color = '#366CE1', height = '12px', width = '12px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.68591 10.1611L3.51946 5.99463L7.68591 1.82819C8.1047 1.4094 8.1047 0.732886 7.68591 0.314094C7.26711 -0.104698 6.5906 -0.104698 6.17181 0.314094L1.24295 5.24295C0.824161 5.66175 0.824161 6.33826 1.24295 6.75705L6.17181 11.6859C6.5906 12.1047 7.26711 12.1047 7.68591 11.6859C8.09396 11.2671 8.1047 10.5799 7.68591 10.1611Z"
      fill={color}
    />
  </svg>
)
